module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "invoiceSwitch"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "1652px",
      "text-align": "center",
      "margin-bottom": "10px",
      "font-size": "12px"
    },
    attrs: {
      "data": _vm.listend,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "小区名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小区开票状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949",
            "active-text": "开",
            "inactive-text": "关"
          },
          on: {
            "change": function($event) {
              return _vm.onChangeState($event, scope.row.id)
            }
          },
          model: {
            value: (scope.row.state),
            callback: function($$v) {
              _vm.$set(scope.row, "state", $$v)
            },
            expression: "scope.row.state"
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "layout": "total,prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-075e9db6"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvoiceSwitch.vue
// module id = 510
// module chunks = 1